const Graph = require('./BaseGraph')

module.exports = class HelpdeskGraph extends Graph 
{
    constructor(apiDomain, path="helpdesk")
    {
        super(apiDomain, path)
    }

    ticketQuery(fields, params=null)
    {
        if (params)
            return { type: 'ticket', query: this.queryString('ticket', fields, params)}

        return { type: 'ticket', query: `query getTicket ($id: ID!) {
            ticket(id: $id)
            ${this.queryFields(fields)}
        }` }
    }

    ticketsQuery(fields, params=null)
    {
        if (params)
            return { type: 'tickets', query: this.queryString('tickets', fields, params)}

        return { type: 'tickets', query: `query getTickets ($userId: String, $search: String, $status: [Int], $priority: [Int], $tags: [String], $limit: Int, $offset: Int) {
            tickets(userId: $userId, search: $search, status: $status, priority: $priority, tags: $tags, limit: $limit, offset: $offset)
            ${this.queryFields(fields)}
        }` }
    }

    repliesQuery(fields, params=null)
    {
        if (params)
            return { type: 'replies', query: this.queryString('replies', fields, params)}

        return { type: 'replies', query: `query getReplies ($ticket_id: ID!, $limit: Int, $offset: Int) {
            replies(ticket_id: $ticket_id, limit: $limit, offset: $offset)
            ${this.queryFields(fields)}
        }` }
    }

    submitTicketMutation(fields, params=null)
    {
        if (params)
            return { type: 'submitTicket', query: `mutation {
                submitTicket(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'submitTicket', query: `mutation submitTicket ($userId: String, $issuer_name: String, $issuer_email: String, $subject: String!, $message: String!, $tagNames: String, $attachments: [Upload]) {
            submitTicket(userId: $userId, issuer_name: $issuer_name, issuer_email: $issuer_email, subject: $subject, message: $message, tagNames: $tagNames, attachments: $attachments)
            ${this.queryFields(fields)}
        }` }
    }

    sendReplyMutation(fields, params=null)
    {
        if (params)
            return { type: 'sendReply', query: `mutation {
                sendReply(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'sendReply', query: `mutation sendReply ($userId: String!, $ticket_id: ID!, $message: String!, $attachments: [Upload]) {
            sendReply(userId: $userId, ticket_id: $ticket_id, message: $message, attachments: $attachments)
            ${this.queryFields(fields)}
        }` }
    }
}